import * as PropTypes from 'prop-types';
import * as React from 'react';
import formatAmount from '../shared/format_amount';

const Savings = ({
  price, bundledPrice, symbol, bundledProductsCount,
}) => {
  const savings = price - bundledPrice;

  if (savings <= 0) {
    return null;
  }

  const savingsText = I18n.t('js.productBundles.promo.savings', {
    amount: formatAmount({ amount: savings, symbol }),
    count: bundledProductsCount,
    totalCount: bundledProductsCount + 1,
  });

  return <p className="strong muted size-90 mb-0">{savingsText}</p>;
};

Savings.propTypes = {
  price: PropTypes.number.isRequired,
  bundledPrice: PropTypes.number,
  symbol: PropTypes.string.isRequired,
  bundledProductsCount: PropTypes.number.isRequired,
};

export default Savings;



// WEBPACK FOOTER //
// ./javascripts/components/product_bundles/savings.jsx